/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountSettings} from '../models/AccountSettings';
import type {Error} from '../models/Error';

export interface SaveAccountSettings$Request {
    accountId: number;
    accountSettings: AccountSettings;
}

export interface SaveAccountSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountSettingsRequest = createAction<PayloadData<void, SaveAccountSettings$Request>>('SAVE_ACCOUNT_SETTINGS__SAVE_ACCOUNT_SETTINGS__REQUEST');
export const saveAccountSettingsSuccess = createAction<PayloadData<void, SaveAccountSettings$Request>>('SAVE_ACCOUNT_SETTINGS__SAVE_ACCOUNT_SETTINGS__SUCCESS');
export const saveAccountSettingsFailure = createAction<PayloadData<Error, SaveAccountSettings$Request, true>>('SAVE_ACCOUNT_SETTINGS__SAVE_ACCOUNT_SETTINGS__FAILURE');

export const saveAccountSettingsActions = [
    saveAccountSettingsRequest,
    saveAccountSettingsSuccess,
    saveAccountSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {AccountSettings} meta.accountSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountSettings = (meta: SaveAccountSettings$Request, config?: SaveAccountSettings$Config) => {
    return {
        CALL_API: {
            types: saveAccountSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/settings`,
            TRANSPORT_REQUEST_BODY: meta.accountSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

